module.exports = __webpack_public_path__ + "static/hail-logo-9cfa435aff98172872b72c72c76f231c.png";